export const isSubdomainUrl = str => {
    const regex = /^(?:https?:\/\/)?(?:[a-zA-Z0-9-]+\.){1}([a-zA-Z0-9-]+)\./;
    return regex.test(str);
}